import { track_ga } from '../firebase'

// 登录用户侧边栏钱包入口点击
export const trackWalletEntry = (params) => {
  track_ga('personal_coins_click', params)
}

/**
 * @params
 * payment_name: String	提交时，选中的支付方式名称
 * amount: String	提交时，要支付的流水金额
 * sku_id: String 提交时，要支付的充值sku
 * quantity:	Number	提交时，购买的sku数量
 * currency:	String	提交时，支付的货币单位
 */
//钱包充值页：充值点击
export const trackClickGoPay = (params) => {
  track_ga('coins_order_click', params)
}

//钱包充值成功页：游戏入口点击
export const trackClickGameEntry = (params) => {
  track_ga('coins_return_game_click', params)
}

/**
 * @params
 * setting: 0：未设置密码；1：已设置
 */
//钱包充值页：修改支付密码入口点击
export const trackClickPasswordEntry = (params) => {
  track_ga('coins_password_click', params)
}

/**
 * @params
 * code: Boolean 设置成功/失败
 */
// 密码绑定结果
export const trackWalletPwBindResult = (params) => {
  track_ga('pay_password_bind', params)
}

// 密码修改结果
export const trackWalletPwChangeResult = (params) => {
  track_ga('pay_password_change', params)
}

/**
 * @params
 * code: Number	使用钱包创建订单接口返回的密码校验结果
 * 密码错误、错误过多、已冻结、成功、余额不足
 */
//钱包交易：支付结果
export const trackWalletPaidResult = (params) => {
  track_ga('pay_password_input_result', params)
}

// 密码设置弹窗曝光
export const trackPwSettingPopupShow = (params) => {
  track_ga('pay_password_set_popup', params)
}

// 游戏商城页余额不足弹窗曝光
export const trackRechargePopupShow = (params) => {
  track_ga('recharge_popup', params)
}

// 游戏商城页余额不足弹窗，点击去充值钱包
export const trackRechargeWallet = (params) => {
  track_ga('recharge_popup_click', params)
}
